export const generatedCandidateSourcePromotionLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-30T00:00:00.000Z",
  "mode": "deterministic-candidate-source-promotion-ledger",
  "operatingRule": "Candidate source custody, resource promotion, and customer use are separate gates. A candidate may promote source custody while resource and customer conclusions remain blocked.",
  "asteroidCandidateEvidenceLedgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
  "candidateSourceWorkOrderCount": 10,
  "reportCount": 1,
  "validReportCount": 1,
  "invalidReportCount": 0,
  "submittedArtifactCount": 10,
  "validationCount": 10,
  "sourceCustodyPromotedCount": 0,
  "resourcePromotedCount": 0,
  "customerUseAllowedCount": 0,
  "promotedWorkOrderIds": [],
  "resourcePromotedWorkOrderIds": [],
  "customerUseWorkOrderIds": [],
  "sourceCustodyPromotionAllowed": false,
  "resourcePromotionAllowed": false,
  "customerUseAllowed": false,
  "promotionState": "blocked-no-candidate-source-custody",
  "blockers": [
    "No candidate-specific source custody artifact has been promoted.",
    "10 candidate source work order(s) still lack promoted source custody."
  ],
  "reportSummaries": [
    {
      "sourcePath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "valid": true,
      "submittedArtifactCount": 10,
      "validationCount": 10,
      "sourceCustodyPromotedCount": 0,
      "resourcePromotedCount": 0,
      "customerUseAllowedCount": 0,
      "blockers": []
    }
  ],
  "workOrderGaps": [
    {
      "workOrderId": "small-body-source-work-order-2026-jm2",
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "name": "2026 JM2",
      "queueRank": 1,
      "reviewPriorityScore": 52.39,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-b52331ce9a5cd6c17d6aafaa4119aee5533301a87cded5d6a06e684cf07fa134"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-em",
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "name": "2026 EM",
      "queueRank": 2,
      "reviewPriorityScore": 44.28,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-5bdb8eb61a495b8a9b53e1cfc73fb5ccdbb5ad0910d3db8a4584ed501c2616f9"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-dn5",
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "name": "2026 DN5",
      "queueRank": 3,
      "reviewPriorityScore": 39.5,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-620143df6681d87f5385af49ebf5ccc6bd18b20679f3e5e292185d1b5f0327d0"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-lx",
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "name": "2026 LX",
      "queueRank": 4,
      "reviewPriorityScore": 39.44,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-8c14435b45122ce12954b3cdff703649a3c597e4399f447c3d66d06c0615617e"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-ku1",
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "name": "2026 KU1",
      "queueRank": 5,
      "reviewPriorityScore": 36.59,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-9f67dd23c5090587d15155d69e13638d980daaa9b46e66af99b0a82c007689d3"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-fs5",
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "name": "2026 FS5",
      "queueRank": 6,
      "reviewPriorityScore": 30.19,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-fs5-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-09109b23d6398297094ed3d3b256f48c4a47f25c782a345c919d9de7ab6154c9"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-et3",
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "name": "2026 ET3",
      "queueRank": 7,
      "reviewPriorityScore": 25.97,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-et3-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-5307e6095ba506ff9e307252b1b93187560a31d7d43a125df1226e73c39a22d7"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-jn4",
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "name": "2026 JN4",
      "queueRank": 8,
      "reviewPriorityScore": 24.65,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jn4-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-db8b7e318dfb4712806ffcd94b5e853eb00e04027da223999f907e3dfd42a8b4"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-jv3",
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "name": "2026 JV3",
      "queueRank": 9,
      "reviewPriorityScore": 24.51,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jv3-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-ae4f5464fe7a729075d1796422f376bef5116a139fa7afe89e1f39f2d18c489f"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-hz4",
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "name": "2026 HZ4",
      "queueRank": 10,
      "reviewPriorityScore": 24.43,
      "reason": "No candidate-specific reviewed source custody intake has passed.",
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-hz4-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-ca56492f342a3ffd2c86d75c51ea4e032263dc65138f58c461ebb42a700b4b92"
    }
  ],
  "resourcePromotionGaps": [],
  "customerUseGaps": [],
  "validations": [
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-jm2-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-jm2",
      "designation": "2026 JM2",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-1949536a416eac109189615a5e82459a4578b5a493dcd615e1413e50c32858a1",
      "promotionRecordHash": "sha256-46d6875387a397e4cc3109254195b46c3f151612ca4795a97356e06e669c85c4"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-em-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-em",
      "designation": "2026 EM",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-ae076bcc8860aadf806b0247a3f36aec296ac911a8e5ab79e333e62a5b55c57c",
      "promotionRecordHash": "sha256-2efa6cfa2d3d32da477f385f4523e3529eea23be1bd1c97f7d437907ec289476"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-dn5-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-dn5",
      "designation": "2026 DN5",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-c5231a7b83457b1c08c90f9c3f355ed338e4849911a819b3ad1200ce1577fd56",
      "promotionRecordHash": "sha256-a3d3a5f26dae62fbfc68c69f1890c449d1aa53f3926562bfc43e9722ee09f6b5"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-lx-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-lx",
      "designation": "2026 LX",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-c4cc553e48bf9022706358b6c76ba76ad460d76fe0ebbdebb6e0b3fc304cca14",
      "promotionRecordHash": "sha256-52bbe5bc6c5e958f702d811e0fce3dae217f832fb8d428cdcaababae8b4a953b"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-ku1-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-ku1",
      "designation": "2026 KU1",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-57da5013b4f952d41c0c96585a2b31da190b0ac51a19e028bfdd78eaebd642cc",
      "promotionRecordHash": "sha256-90108d23ae39cc461b00a8e8d61489adfb5b3b6281e47f85e1c535b84595c8ef"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-fs5-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-fs5",
      "designation": "2026 FS5",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-e144c6664c596e146d4ba694672b68ca573e27d263f8e1ed03e6c3bf73bdfdf4",
      "promotionRecordHash": "sha256-3748d160ef42acb832d450aff7e9dcecdf4eaf358125ca518d4f4560b6b7b41c"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-et3-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-et3",
      "designation": "2026 ET3",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-e0f70405482c25988361bdc52da4350a233a2ed22a5b0967ef22c73e084ed65b",
      "promotionRecordHash": "sha256-0b0f31ddd1e7d0dc92b0c1b1ba8c854abb669e25083b60a9ee8469a31c858509"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-jn4-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-jn4",
      "designation": "2026 JN4",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-25b9759df75bc09b9717c320f6ed87536bda0cf211e80977b7fe987678bd7d35",
      "promotionRecordHash": "sha256-30535dadb8daee3b6714ebcb63d4d2455f3a56a7ec1b35e42e84af8f839f7ad6"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-jv3-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-jv3",
      "designation": "2026 JV3",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-47b0bd98523e8f119712590a781b27c6153c9f4f7c7987fe3999a4636ab01c76",
      "promotionRecordHash": "sha256-02340feb061034b21ec4786102db1aab0f235b292c75a38ea66600714f75e108"
    },
    {
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "artifactId": "small-body-source-work-order-2026-hz4-draft-source-artifact",
      "workOrderId": "small-body-source-work-order-2026-hz4",
      "designation": "2026 HZ4",
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingFields": [],
      "querySourceGaps": [
        "mpc"
      ],
      "attachedEvidenceTypes": [
        "cad-close-approach-record",
        "sbdb-orbit-record"
      ],
      "blockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "warningNotes": [
        "Resource composition remains blocked: no taxonomy, spectra, or mission/archive evidence attached.",
        "Customer use remains blocked: source-use clearance is missing or unapproved."
      ],
      "nextAction": "SBDB object payload with raw and normalized hashes.",
      "validationHash": "sha256-43575c4fcd6a272cf7824bf0891be875e70afc2d81ddf8cfe755b729acd01b20",
      "promotionRecordHash": "sha256-c48056ef5828a68336d06f446971e8a847158f6e236807b013ad2d40e2909195"
    }
  ],
  "nextAction": "Place reviewed candidate source work-order intake reports in evidence/source-candidate-work-order-reports and regenerate science reports.",
  "ledgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a"
}
;
